import fp from 'lodash/fp'

import { combine, withContext, withCallbacks } from 'react-hooks-combine'
import { withFormModel, withMobxAutorun } from 'shared/hooks'
import { spec, validators } from 'utils/validation'
import { saveExcelFile } from 'utils/excel-generation'
import { ServicesContext } from 'services/context'
import { convertToExcel, filterConverter } from './helpers'

import InWinFiltersComponent from './component'

const { custom } = validators

export const InWinFilters = combine(
  withContext(
    'adminInWinsService',
    ServicesContext,
    ({ adminInWinsService }) => adminInWinsService
  ),

  withFormModel(
    {
      dateFrom: {
        initialValue: '',
        spec: spec.flow(custom.valid),
      },
      dateTo: {
        initialValue: '',
        spec: spec.flow(custom.valid),
      },
    },
    { id: 'in-win-filters-form' }
  ),

  withCallbacks(
    {
      exportToExcel:
        ({ adminInWinsService }) =>
        async (form) => {
          const { content } = await adminInWinsService.queryInWinSearch(
            filterConverter(
              form.fields.dateFrom.value,
              form.fields.dateTo.value
            ),
            { page: 0, size: 10000 }
          )
          const excelData = convertToExcel(content)
          saveExcelFile('inWinStats', excelData)
        },

      onSearchRequest: {
        deps: ['debounce', 'onSearch'],
        func: (_state, { debounce, onSearch }) => {
          return fp.isNumber(debounce)
            ? fp.debounce(debounce, onSearch)
            : onSearch
        },
      },
    },
    []
  ),

  withMobxAutorun(
    ({ state: { form, onSearchRequest } }) => {
      const dateFromControl = form.getControl('dateFrom')
      const dateToControl = form.getControl('dateTo')
      onSearchRequest(
        filterConverter(dateFromControl.value, dateToControl.value)
      )
    },
    ['onSearchRequest']
  )
)(InWinFiltersComponent)
